import * as React from 'react';
import { Container, Header, Label } from 'semantic-ui-react';
import './style.css';
import { ButtonLarge } from 'theme';


export interface IGetAppProps {
  signInSignUp: (ctaButtonText) => void;
}

export const GetApp: React.SFC<IGetAppProps> = ({ signInSignUp }) => {
  const ctaButtonText = "Sign Up";
  return <div className="landing-feature-alt">
    <Container>
      <div className="landing-getapp__block">
        <img className="landing-getapp__icon" src="assets/images/app-icon.png" />
        <Header as="h2" className="landing-getapp__title">
          <span>Fluent Forever</span> <Label tag>BETA</Label>
        </Header>
        <p className="landing-getapp__description">
          Discover the immersive mobile experience designed to unlock <br />
          your ability to learn a new language and never forget it.
        </p>
        <div className="landing-getapp__flags-container">
          <div>
            <img src="assets/images/spanish.png" />
            <div className="subtext text-tiny color-dark">Spanish (LA)</div>
          </div>
          <div >
            <img src="assets/images/french.png" />
            <div className="subtext text-tiny color-dark">French</div>
          </div>
          <div >
            <img src="assets/images/german.png" />
            <div className="subtext text-tiny color-dark">German</div>
          </div>
          <div >
            <img src="assets/images/italian.png" />
            <div className="subtext text-tiny color-dark">Italian</div>
          </div>
          <div >
            <img src="assets/images/brazil.png" />
            <div className="subtext text-tiny color-dark">Portuguese<br />(Brazilian)</div>
          </div>
          <div >
            <img src="assets/images/spanish-ca.png" />
            <div className="subtext text-tiny color-dark">Spanish<br />(Castilian)</div>
          </div>
          <div >
            <img src="assets/images/russian.png" />
            <div className="subtext text-tiny color-dark">Russian</div>
          </div>
        </div>
        <ButtonLarge className="landing-getapp__button" onClick={() => signInSignUp(ctaButtonText)}>
          {ctaButtonText}
        </ButtonLarge>
      </div>
    </Container>
  </div>
}



// WEBPACK FOOTER //
// ./src/components/presentational/views/Landing/sections/GetApp/index.tsx